export default __webpack_public_path__ + "static/media/iPhone-X2.ba05807b.png";